import React from 'react';
import { FeedList } from './FeedList';

export const NewsList: React.FC = () => {
    return <FeedList type="news" />;
};
